// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__dF0pN","totalList":"styles_totalList__DRHts","btnWrapper":"styles_btnWrapper__sn9n+"};